import { render, staticRenderFns } from "./CellRendererAdditionalFields.vue?vue&type=template&id=c019d78c"
import script from "./CellRendererAdditionalFields.vue?vue&type=script&lang=js"
export * from "./CellRendererAdditionalFields.vue?vue&type=script&lang=js"
import style0 from "./CellRendererAdditionalFields.vue?vue&type=style&index=0&id=c019d78c&prod&lang=scss&scpoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports